import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('FIXED ASSET CONFIGURATIONS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class FixedAssetConfigurationsService extends ApiBaseService<any>{

  constructor() {
    // Recurso del catálogo de Configuración de Activo Fijo
    super('fixedAssetConfigurations');
    log.debug('Servicio de Configuración de Activo Fijo inicializado');
  }

}
